import React, { useState, useEffect } from 'react';
import axios from 'axios';

function Dashboard() {
  const [stats, setStats] = useState({
    soustraitantsActifs: 0,
    dc4EnCours: 0,
    documentsARenouveler: 0,
    soustraitantsAJour: 0
  });
  const [loading, setLoading] = useState(true);
  const [alertes, setAlertes] = useState([]);

  useEffect(() => {
    fetchStats();
    fetchAlertes();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await axios.get('/api/dashboard/stats');
      setStats(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Erreur lors du chargement des statistiques:', error);
      setLoading(false);
    }
  };

  const fetchAlertes = async () => {
    try {
      const response = await axios.get('/api/dashboard/alertes');
      setAlertes(response.data);
    } catch (error) {
      console.error('Erreur alertes:', error);
    }
  };

  const handleTraiter = async (id) => {
    try {
      await axios.put(`/api/dashboard/alertes/${id}/traiter`);
      setAlertes(prev => prev.filter(a => a.id !== id));
    } catch (error) {
      alert('Erreur');
    }
  };

  if (loading) {
    return <div className="loading">Chargement...</div>;
  }

  return (
    <div className="dashboard">
      <h1 style={{ marginBottom: '2rem' }}>Tableau de Bord</h1>
      
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-value">{stats.soustraitantsActifs}</div>
          <div className="stat-label">Sous-traitants Actifs</div>
        </div>
        
        <div className="stat-card">
          <div className="stat-value">{stats.dc4EnCours}</div>
          <div className="stat-label">DC4 en Cours</div>
        </div>
        
        <div className="stat-card">
          <div className="stat-value">{stats.soustraitantsAJour}</div>
          <div className="stat-label">Sous-traitants à Jour</div>
        </div>
        
        <div className="stat-card">
          <div className="stat-value">{stats.documentsARenouveler}</div>
          <div className="stat-label">Documents à Renouveler</div>
        </div>
      </div>

      {alertes.length > 0 && (
        <div className="card" style={{ borderLeft: '4px solid #e67e22' }}>
          <div className="card-header">
            <h2 className="card-title">
              📨 Alertes documents
              <span style={{ marginLeft: '0.5rem', background: '#e67e22', color: '#fff',
                borderRadius: '10px', padding: '0.15rem 0.6rem', fontSize: '0.8rem' }}>
                {alertes.length}
              </span>
            </h2>
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f8f9fa' }}>
                <th style={{ padding: '0.6rem 1rem', textAlign: 'left', fontSize: '0.8rem', fontWeight: 700, color: '#95a5a6' }}>Référence</th>
                <th style={{ padding: '0.6rem 1rem', textAlign: 'left', fontSize: '0.8rem', fontWeight: 700, color: '#95a5a6' }}>Sous-traitant</th>
                <th style={{ padding: '0.6rem 1rem', textAlign: 'left', fontSize: '0.8rem', fontWeight: 700, color: '#95a5a6' }}>Statut</th>
                <th style={{ padding: '0.6rem 1rem', textAlign: 'left', fontSize: '0.8rem', fontWeight: 700, color: '#95a5a6' }}>Fichiers</th>
                <th style={{ padding: '0.6rem 1rem', textAlign: 'left', fontSize: '0.8rem', fontWeight: 700, color: '#95a5a6' }}>Date</th>
                <th style={{ padding: '0.6rem 1rem' }}></th>
              </tr>
            </thead>
            <tbody>
              {alertes.map(a => (
                <tr key={a.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ padding: '0.6rem 1rem', fontWeight: 600, fontSize: '0.88rem' }}>{a.code_suivi}</td>
                  <td style={{ padding: '0.6rem 1rem' }}>
                    <a href={`/soustraitants/${a.soustraitant_codification}`} style={{ color: '#3498db', textDecoration: 'none' }}>
                      {a.soustraitant_nom || a.soustraitant_codification}
                    </a>
                  </td>
                  <td style={{ padding: '0.6rem 1rem' }}>
                    <span className={`badge ${a.statut === 'recue' ? 'badge-success' : 'badge-warning'}`}>
                      {a.statut === 'recue' ? '📥 Documents reçus' : '⏳ En attente'}
                    </span>
                  </td>
                  <td style={{ padding: '0.6rem 1rem', fontSize: '0.85rem' }}>
                    {a.fichiers_recus ? `${a.fichiers_recus.length} fichier(s)` : '—'}
                  </td>
                  <td style={{ padding: '0.6rem 1rem', fontSize: '0.85rem', color: '#7f8c8d' }}>
                    {a.date_reception
                      ? new Date(a.date_reception).toLocaleDateString('fr-FR')
                      : new Date(a.date_envoi).toLocaleDateString('fr-FR')}
                  </td>
                  <td style={{ padding: '0.6rem 1rem', textAlign: 'right' }}>
                    {a.statut === 'recue' && (
                      <div style={{ display: 'flex', gap: '0.4rem', justifyContent: 'flex-end' }}>
                        <a href={`/soustraitants/${a.soustraitant_codification}`}
                          style={{ padding: '0.3rem 0.7rem', background: '#3498db', color: '#fff', borderRadius: '4px', textDecoration: 'none', fontSize: '0.8rem', fontWeight: 600 }}>
                          Voir
                        </a>
                        <button onClick={() => handleTraiter(a.id)}
                          style={{ padding: '0.3rem 0.7rem', background: '#27ae60', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '0.8rem', fontWeight: 600 }}>
                          ✓ Traité
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="card">
        <div className="card-header">
          <h2 className="card-title">Actions Rapides</h2>
        </div>
        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
          <a href="/soustraitants" className="btn btn-primary">Gérer les sous-traitants</a>
          <a href="/dc4/new" className="btn btn-success">Créer un DC4</a>
          <a href="/marches" className="btn btn-secondary">Voir les marchés</a>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h2 className="card-title">Efficacité Commerciale</h2>
        </div>
        <div className="detail-grid">
          <div className="detail-item">
            <div className="detail-label">Taux de sous-traitants à jour</div>
            <div className="detail-value">
              {stats.soustraitantsActifs > 0 
                ? Math.round((stats.soustraitantsAJour / stats.soustraitantsActifs) * 100)
                : 0}%
            </div>
          </div>
          <div className="detail-item">
            <div className="detail-label">Contrats actifs</div>
            <div className="detail-value">{stats.dc4EnCours}</div>
          </div>
          <div className="detail-item">
            <div className="detail-label">Alertes documents</div>
            <div className="detail-value">
              {stats.documentsARenouveler > 0 ? (
                <span className="badge badge-warning">{stats.documentsARenouveler} à traiter</span>
              ) : (
                <span className="badge badge-success">Tout est à jour</span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
